import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { ValidationErrorType } from 'aem-libs-react-ts/src/constants/ValidationErrorType'
import { inputId } from 'aem-libs-tests/src/constants/inputId'
import { createTestId } from 'aem-libs-tests/src/utility/createTestId'
import { Maybe } from 'aem-libs-ts/src/types/utility'

import errorIco from '../../../assets/error.svg'
import { BORDER_RADIUS } from '../../../styles'
import { invalidValueMessageId } from '../invalidValueMessageId'
import cs from './i18n/cs.json'
import en from './i18n/en.json'


const ValidationMessageStyled = styled.div`
  text-align: left;
  font-size: 14px;
  background: ${({ theme }) => theme.colors.common.extraLight.pink} no-repeat 10px 10px;
  border: 1px solid ${({ theme }) => theme.colors.common.regular.pink};
  background-image: url(${errorIco});
  min-height: 21px;
  padding: 7px 7px 7px 35px;
  border-radius: ${BORDER_RADIUS};
  margin-top: 5px;
`

export interface ValidationMessageProps {
  message: Maybe<string>
  className?: string
  id?: Maybe<string>
  testId?: string
  label?: string
}

export const ValidationMessage = ({ message, className, id, testId, label }: ValidationMessageProps) => {
  const { t, i18n } = useTranslation('ValidationError')
  i18n.addResourceBundle('cs', 'ValidationError', cs)
  i18n.addResourceBundle('en', 'ValidationError', en)

  const isStandardMessage = () =>
    message &&
    Object.values<string>(ValidationErrorType)
      .map((v) => v.toLowerCase())
      .includes(message.toLowerCase())

  const errorMessage = isStandardMessage() ? t('VALIDATION_ERROR.' + message?.toLowerCase()) : message

  return (
    <ValidationMessageStyled
      data-testid={createTestId(testId ?? 'validation-message', inputId.error)}
      className={className}
      role={'status'}
      aria-live={'polite'}
      aria-label={`${label ?? label} ${errorMessage}`}
      id={id && id?.length > 0 ? invalidValueMessageId(id) : 'validation-error'}
    >
      {errorMessage}
    </ValidationMessageStyled>
  )
}
